import React from 'react';
import logo from '../../assets/Logo/vps infrastructure logo.png';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Retrieve the specific data we just stored
  const userName = localStorage.getItem('userName') || 'VPS User';
  const userRole = localStorage.getItem('userRole') || 'Staff';
  const userEmail = localStorage.getItem('userEmail') || 'contact@vps.com';

  const isActive = (path) => location.pathname === path;

  const handleLogout = () => {
    localStorage.clear();
    navigate('/admin');
  };

  return (
    <div className="bg-white border-end shadow-sm d-flex flex-column" id="sidebar-wrapper" style={{ height: '100vh' }}>
      <div className="sidebar-heading px-4 py-4 d-flex align-items-center justify-content-center">
        <img src={logo} alt="VPS Logo" style={{ height: '140px', width: '100%', maxWidth: '160px', objectFit: 'contain' }} />
      </div>

      <div className="list-group list-group-flush px-3 flex-grow-1">
        <small className="text-muted fw-bold mb-2 ps-3" style={{ fontSize: '11px', letterSpacing: '0.8px' }}>DASHBOARD</small>
        
        <Link to="/dashboard" className={`list-group-item list-group-item-action border-0 rounded-3 mb-1 py-2 ${isActive('/dashboard') ? 'bg-primary-subtle text-primary fw-bold' : ''}`}>
          <i className="bi bi-speedometer2 me-2"></i> Dashboard
        </Link>
        
        <div className="nav-section-title mt-4 mb-2 text-muted fw-bold ps-3">
          <small style={{ fontSize: '11px', letterSpacing: '0.8px' }}>WIDGETS</small>
        </div>

        <Link to="/dashboard/projects" className={`list-group-item list-group-item-action border-0 rounded-3 mb-1 py-2 ${isActive('/dashboard/projects') ? 'bg-primary-subtle text-primary fw-bold' : ''}`}>
          <i className="bi bi-pie-chart me-2"></i> Projects
        </Link>

        <Link to="/dashboard/contact" className={`list-group-item list-group-item-action border-0 rounded-3 mb-1 py-2 ${isActive('/dashboard/contact') ? 'bg-primary-subtle text-primary fw-bold' : ''}`}>
          <i className="bi bi-chat-left-dots me-2"></i> Contact Us
        </Link>

        <Link to="/dashboard/reviews" className={`list-group-item list-group-item-action border-0 rounded-3 mb-1 py-2 ${isActive('/dashboard/reviews') ? 'bg-primary-subtle text-primary fw-bold' : ''}`}>
          <i className="bi bi-star me-2"></i> Reviews
        </Link>

        {/* --- ADMIN ONLY LINK --- */}
        {userRole.toLowerCase() === 'admin' && (
          <Link 
            to="/dashboard/login" 
            className={`list-group-item list-group-item-action border-0 rounded-3 mb-1 py-2 ${
              isActive('/dashboard/login') ? 'bg-primary-subtle text-primary fw-bold' : ''
            }`}
          >
            <i className="bi bi-shield-lock me-2"></i> Login Details
          </Link>
        )}
      </div>

      {/* Profile Footer */}
      <div className="sidebar-footer mt-auto border-top">
        <div className="p-3 d-flex align-items-center bg-light-subtle">
          <img 
            src={`https://ui-avatars.com/api/?name=${userName}&background=002147&color=fff`} 
            className="rounded-circle me-2 border" 
            alt="user" 
            width="40" 
          />
          <div className="user-info small overflow-hidden">
            <div className="fw-bold text-dark text-truncate" style={{ maxWidth: '130px' }}>{userName}</div>
            <div className="text-muted text-truncate" style={{ maxWidth: '130px', fontSize: '11px' }}>{userEmail}</div>
            <span className="badge bg-primary-subtle text-primary mt-1" style={{ fontSize: '9px' }}>{userRole.toUpperCase()}</span>
          </div>
        </div>
        
        <button onClick={handleLogout} className="btn btn-link text-danger text-decoration-none w-100 py-3 d-flex align-items-center px-4">
          <i className="bi bi-box-arrow-left me-2"></i> 
          <span className="fw-bold">Logout</span>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;